// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 5H22V19H2V5ZM4 7V17H20V7H4ZM6 9H18V15H6V9Z"}}]};

const ButtonFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'button-filled',
    ref,
    icon: element,
  },
));

ButtonFilledIcon.displayName = 'ButtonFilledIcon';

export default ButtonFilledIcon;
